import { axiosClient } from '@services/axios';
import { getPagebySlugUrl, getPageSlugByIdUrl } from '@services/pages/pages.services';
import { IPageBySlugResponse, IPageSlugByIdResponse } from '@services/pages/pages.services.type';
import { GetStaticPaths, GetStaticProps } from 'next';
import { formatRichText, jsonToObject } from 'src/functions/functions';

export { LegalPage as default } from 'src/features/legal/components/LegalPage/LegalPage';

export const getStaticProps: GetStaticProps = async (ctx) => {
	const { slug } = ctx.params || { slug: '' };

	if (!slug) {
		return {
			notFound: true
		};
	}

	try {
		const res = (await axiosClient.get(getPagebySlugUrl(String(slug)))) as IPageBySlugResponse;

		const { id, attributes } = res.data.data[0];

		return {
			props: {
				id: id,
				title: attributes?.title,
				type: attributes?.type,
				description: formatRichText(jsonToObject(attributes?.description).blocks || []),
				slug: attributes?.slug,
				coverUrl: attributes?.cover?.url || ''
			},
			revalidate: process.env.BUILD_ENV === 'production' ? 5 * 60 : 10 // 1800
		};
	} catch {
		return {
			notFound: true
		};
	}
};

export const getStaticPaths: GetStaticPaths = async () => {
	const ids = [
		2, // Privacy Policy
		3 // Terms of Service
	];
	const res = (await axiosClient.get(getPageSlugByIdUrl(ids))) as IPageSlugByIdResponse;

	const paths = res.data.data.map(({ attributes: { slug } }: { attributes: { slug: string } }) => ({
		params: {
			slug
		}
	}));

	return {
		paths: paths,
		fallback: true
	};
};
